import simpleFogOfWar from './simpleFogOfWar'

export default {
  simpleFogOfWar
};


/** WEBPACK FOOTER **
 ** ./src/extensions/fogOfWars/index.js
 **/